import { render, staticRenderFns } from "./SiTweenNumber.vue?vue&type=template&id=2a6c5de6&scoped=true&lang=html&"
import script from "./SiTweenNumber.vue?vue&type=script&lang=js&"
export * from "./SiTweenNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6c5de6",
  null
  
)

export default component.exports